module.exports = __webpack_public_path__ + "static/container-ship.f6efbcea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/graphics/container-ship.svg
// module id = 486
// module chunks = 33781710060979